/* eslint-disable no-unused-vars */
import { T } from "../../lib/globals";

const SVC_TYPES = {
  internal:   {label:"Serviço Interno",   icon:"🔨", color:"#3B82F6"},
  occurrence: {label:"Ocorrência",         icon:"🚨", color:"#EF4444"},
  external:   {label:"Serviço de Terceiro",icon:"👷", color:"#0D9488"},
};


const SVC_PRIORITIES_INTERNAL = [
  {id:"low",    label:"Baixa",  color:"#22C55E", icon:"🟢"},
  {id:"medium", label:"Média",  color:"#64748B", icon:"⚪"},
  {id:"normal", label:"Normal", color:"#3B82F6", icon:"🔵"},
];


const SVC_PRIORITIES_OCCURRENCE = [
  {id:"normal",    label:"Normal",     color:"#3B82F6", icon:"🔵"},
  {id:"high",      label:"Alta",       color:"#F59E0B", icon:"🟠"},
  {id:"urgent",    label:"Urgente",    color:"#EF4444", icon:"🔴"},
  {id:"emergency", label:"Emergência", color:"#7C3AED", icon:"🚨"},
];


const SVC_PRIORITIES_EXTERNAL = [
  {id:"low",    label:"Baixa",  color:"#22C55E", icon:"🟢"},
  {id:"medium", label:"Média",  color:"#64748B", icon:"⚪"},
  {id:"normal", label:"Normal", color:"#3B82F6", icon:"🔵"},
];


function getPriorities(type) {
  if(type==="occurrence") return SVC_PRIORITIES_OCCURRENCE;
  if(type==="external")   return SVC_PRIORITIES_EXTERNAL;
  return SVC_PRIORITIES_INTERNAL;
}


function getPriorityConfig(type, id) {
  return getPriorities(type).find(p=>p.id===id) || {label:id||"Normal",color:"#64748B",icon:"⚪"};
}


const SVC_STATUS_FLOW = {
  // Internal services
  "Aberto":              {color:"#EF4444", icon:"🔴", order:0, allowedRoles:["all"]},
  "Agendado":            {color:"#F59E0B", icon:"📅", order:1, allowedRoles:["all"]},
  "Em Execução":         {color:"#3B82F6", icon:"⚙️", order:2, allowedRoles:["all"]},
  "Pausada":             {color:"#F97316", icon:"⏸️", order:3, allowedRoles:["all"]},
  "Concluído":           {color:"#22C55E", icon:"✅", order:5, allowedRoles:["all"]},
  "Cancelado":           {color:"#94A3B8", icon:"🚫", order:6, allowedRoles:["gestor","admin"]},
  // External/occurrence flow
  "Orçamento Solicitado":{color:"#F97316", icon:"📋", order:1, allowedRoles:["all"]},
  "Orçamento Recebido":  {color:"#8B5CF6", icon:"💰", order:2, allowedRoles:["all"]},
  "Aguardando Aprovação":{color:"#EAB308", icon:"⏳", order:3, allowedRoles:["all"]},
  "Aprovado":            {color:"#22C55E", icon:"✅", order:4, allowedRoles:["gestor","admin"]},
  "Negado":              {color:"#EF4444", icon:"❌", order:4, allowedRoles:["gestor","admin"]},
};


function getEditableServiceStatuses(type, service={}) {
  const base = type === "external"
    ? ["Aberto","Agendado","Em Execução","Pausada","Concluído","Cancelado","Orçamento Solicitado","Orçamento Recebido","Aguardando Aprovação","Aprovado","Negado"]
    : ["Aberto","Agendado","Em Execução","Pausada","Concluído","Cancelado"];
  const current = service?.status;
  return Array.from(new Set([...(current ? [current] : []), ...base]));
}

// Days thresholds for date warnings


const SVC_WARN_DAYS  = 15;


const SVC_ALERT_DAYS = 30;


function daysSince(dateStr) {
  if(!dateStr) return 0;
  return Math.floor((Date.now() - new Date(dateStr).getTime()) / 86400000);
}


function dateColor(dateStr, warnDays=SVC_WARN_DAYS, alertDays=SVC_ALERT_DAYS) {
  const days = daysSince(dateStr);
  if(days >= alertDays) return "#EF4444";
  if(days >= warnDays)  return "#F59E0B";
  return null; // normal
}


const roleColor    = {admin:T.red, gestor:T.accent, solicitante:T.purple};


// ── SystemListsManager — admin panel tab for managing all dropdown lists ──────

export {
  SVC_TYPES, SVC_PRIORITIES_INTERNAL, SVC_PRIORITIES_OCCURRENCE, SVC_PRIORITIES_EXTERNAL,
  getPriorities, getPriorityConfig, SVC_STATUS_FLOW, getEditableServiceStatuses,
  SVC_WARN_DAYS, SVC_ALERT_DAYS, daysSince, dateColor, roleColor,
};
